export default {
  key1: 'key 1 internationalization',
  key2: 'key 2 internationalization',

  Form: {
    URL: 'URL',
  },
};
